var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCopyIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 17,
    viewBox: "0 0 15 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4F6EF7",
    d: "M14.0526316,3 L4.57894737,3 C3.71052632,3 3,3.69545455 3,4.54545455 L3,15.3636364 L4.57894737,15.3636364 L4.57894737,4.54545455 L14.0526316,4.54545455 L14.0526316,3 Z M16.4210526,6.09090909 L7.73684211,6.09090909 C6.86842105,6.09090909 6.15789474,6.78636364 6.15789474,7.63636364 L6.15789474,18.4545455 C6.15789474,19.3045455 6.86842105,20 7.73684211,20 L16.4210526,20 C17.2894737,20 18,19.3045455 18,18.4545455 L18,7.63636364 C18,6.78636364 17.2894737,6.09090909 16.4210526,6.09090909 Z M16.4210526,18.4545455 L7.73684211,18.4545455 L7.73684211,7.63636364 L16.4210526,7.63636364 L16.4210526,18.4545455 Z",
    transform: "translate(-3 -3)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyIcon);
export default __webpack_public_path__ + "static/media/copy-icon.0b9b0ebd6031162174988be7dc1b41c5.svg";
export { ForwardRef as ReactComponent };